import React from "react";
import s from "./LoadingElement.module.scss";

export const LoadingElement: React.FC<{ text?: string }> = ({
  text = "Loading...",
}) => {
  return <div className={s.loading}>{text}</div>;
};
